import { useTeethStore } from '../store/teethStore';

export const useTeeth = () => {
  const upperOpacity = useTeethStore((state) => state.upperOpacity);
  const lowerOpacity = useTeethStore((state) => state.lowerOpacity);
  const showGrid = useTeethStore((state) => state.showGrid);
  const showAxes = useTeethStore((state) => state.showAxes);
  const showUpperJaw = useTeethStore((state) => state.showUpperJaw);
  const showLowerJaw = useTeethStore((state) => state.showLowerJaw);
  const currentScanIndex = useTeethStore((state) => state.currentScanIndex);
  const upperJawFile = useTeethStore((state) => state.upperJawFile);
  const lowerJawFile = useTeethStore((state) => state.lowerJawFile);

  const setUpperOpacity = useTeethStore((state) => state.setUpperOpacity);
  const setLowerOpacity = useTeethStore((state) => state.setLowerOpacity);
  const toggleGrid = useTeethStore((state) => state.toggleGrid);
  const toggleAxes = useTeethStore((state) => state.toggleAxes);
  const toggleUpperJaw = useTeethStore((state) => state.toggleUpperJaw);
  const toggleLowerJaw = useTeethStore((state) => state.toggleLowerJaw);
  const setCurrentScanIndex = useTeethStore((state) => state.setCurrentScanIndex);
  const setUpperJawFile = useTeethStore((state) => state.setUpperJawFile);
  const setLowerJawFile = useTeethStore((state) => state.setLowerJawFile);

  return {
    upperOpacity,
    lowerOpacity,
    showGrid,
    showAxes,
    showUpperJaw,
    showLowerJaw,
    currentScanIndex,
    upperJawFile,
    lowerJawFile,

    setUpperOpacity,
    setLowerOpacity,
    toggleGrid,
    toggleAxes,
    toggleUpperJaw,
    toggleLowerJaw,
    setCurrentScanIndex,
    setUpperJawFile,
    setLowerJawFile,
  };
};

export default useTeeth;
